import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let SearchMixin = class SearchMixin extends Vue {
    constructor() {
        super(...arguments);
        this.search = null;
    }
    onSearch(keyword) {
        this.search = keyword;
    }
};
SearchMixin = __decorate([
    Component
], SearchMixin);
export default SearchMixin;
